import { GetOptions } from "@/core";
import { repositoryHost } from "@/repositories";
import { serviceHost } from "@/services";
import { useInfiniteQuery } from "@tanstack/react-query";
import { getNextPageParam } from "../utils/page-params";

const databaseService = serviceHost.getDatabaseService();
const eventRepository = repositoryHost.getEventRepository(databaseService);

export const useGetEventsByCustomerId = (
  options: GetOptions,
  customerId: string,
) => {
  return useInfiniteQuery({
    queryKey: ["events", "get", customerId, JSON.stringify(options)],
    queryFn: ({ pageParam }) =>
      eventRepository.getAll({
        ...options,
        pagination: {
          ...options.pagination,
          cursor: pageParam,
        },
        queryConstraints: [
          { field: "customerId", operator: "==", value: customerId.toString() },
        ],
      }),
    initialPageParam: "",
    getNextPageParam: getNextPageParam(options),
  });
};

export const useGetEventsByDealId = (options: GetOptions, dealId: string) => {
  return useInfiniteQuery({
    queryKey: ["event", "dealId", dealId],
    queryFn: ({ pageParam }) =>
      eventRepository.getAll({
        ...options,
        queryConstraints: [
          { field: "hubspotDealId", operator: "==", value: dealId },
        ],
        pagination: {
          ...options.pagination,
          cursor: pageParam,
        },
      }),
    initialPageParam: "",
    getNextPageParam: getNextPageParam(options),
  });
};
